import { useQuery } from "@tanstack/react-query";
import { fetchPatientGraphPaths } from "../services/insights";
import { usePatientStore } from "../stores/patientStore";

export function usePatientGraphPaths(patientId?: string) {
  const setGraphPaths = usePatientStore((state) => state.setGraphPaths);
  const cachedPaths = usePatientStore((state) =>
    patientId ? state.graphPaths[patientId] : undefined,
  );

  return useQuery({
    queryKey: ["patient-graph-paths", patientId],
    queryFn: async ({ signal }) => {
      if (!patientId) {
        throw new Error("patientId is required");
      }
      const response = await fetchPatientGraphPaths(patientId, signal);
      if (response.graphPaths) {
        setGraphPaths(patientId, response.graphPaths);
      }
      return response.graphPaths;
    },
    enabled: Boolean(patientId),
    initialData: cachedPaths,
    staleTime: 5 * 60 * 1000,
  });
}
